export function ErrorIcon({
  className,
  color = "#FF495B",
}: {
  className?: string;
  color?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 12C2.25 6.615 6.615 2.25 12 2.25C17.385 2.25 21.75 6.615 21.75 12C21.75 17.385 17.385 21.75 12 21.75C6.615 21.75 2.25 17.385 2.25 12ZM8.47 8.47C8.32955 8.61063 8.25066 8.80125 8.25066 9C8.25066 9.19875 8.32955 9.38937 8.47 9.53L10.94 12L8.47 14.47C8.39631 14.5387 8.33721 14.6215 8.29622 14.7135C8.25523 14.8055 8.23318 14.9048 8.23141 15.0055C8.22963 15.1062 8.24816 15.2062 8.28588 15.2996C8.3236 15.393 8.37974 15.4778 8.45096 15.549C8.52218 15.6203 8.60701 15.6764 8.7004 15.7141C8.79379 15.7518 8.89382 15.7704 8.99452 15.7686C9.09522 15.7668 9.19454 15.7448 9.28654 15.7038C9.37854 15.6628 9.46134 15.6037 9.53 15.53L12 13.06L14.47 15.53C14.6122 15.6625 14.8002 15.7346 14.9945 15.7312C15.1888 15.7277 15.3742 15.649 15.5116 15.5116C15.649 15.3742 15.7277 15.1888 15.7312 14.9945C15.7346 14.8002 15.6625 14.6122 15.53 14.47L13.06 12L15.53 9.53C15.6625 9.38783 15.7346 9.19978 15.7312 9.00548C15.7277 8.81118 15.649 8.62579 15.5116 8.48838C15.3742 8.35097 15.1888 8.27225 14.9945 8.26882C14.8002 8.2654 14.6122 8.33752 14.47 8.47L12 10.94L9.53 8.47C9.38937 8.32955 9.19875 8.25066 9 8.25066C8.80125 8.25066 8.61063 8.32955 8.47 8.47Z"
        fill={color}
      />
    </svg>
  );
}
